module.exports = __webpack_public_path__ + "static/sample-25-c876ae7404b7ec07b65589d455796b89.png";